import { render, staticRenderFns } from "./retail_bSales.vue?vue&type=template&id=398b68bf&scoped=true"
import script from "./retail_bSales.vue?vue&type=script&lang=js"
export * from "./retail_bSales.vue?vue&type=script&lang=js"
import style0 from "./retail_bSales.vue?vue&type=style&index=0&id=398b68bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b68bf",
  null
  
)

export default component.exports